import { render } from "./MasterDataRows.vue?vue&type=template&id=1dec24fb&scoped=true&ts=true"
import script from "./MasterDataRows.vue?vue&type=script&lang=ts"
export * from "./MasterDataRows.vue?vue&type=script&lang=ts"

import "./MasterDataRows.vue?vue&type=style&index=0&id=1dec24fb&lang=scss&scoped=true"
import "./MasterDataRows.vue?vue&type=style&index=1&id=1dec24fb&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dec24fb"]])

export default __exports__